<template>
    <div>
        <el-dialog
            title="修改意见"
            :close-on-click-modal="false"
            :visible.sync="afterSales"
            width="30%"
        >
            <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="100px"
                class="demo-ruleForm"
            >
                <el-form-item label="修改意见：" prop="complainContent" >
                    <el-input type="textarea" v-model="ruleForm.complainContent"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="afterSales = false">取 消</el-button>
                    <el-button @click="submitForm('ruleForm')">确 定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: "complaintsDialog",
    data() {
        return {
            afterSales: false,
            ruleForm: {
                complainContent: "",
            },
            fileList: [],
            rules: {
                complainContent: [
                    {
                        required: true,
                        message: "请填写售后原因",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    methods: {
        init() {
            this.afterSales = true;
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
    },
};
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/views/transaction/orderManagement/amendmentsDialog.vue